var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseWhiteV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 19.4992V14.9991C14.2495 14.8001 14.1704 14.6094 14.0298 14.4687C13.8891 14.3281 13.6984 14.2491 13.4995 14.2491H10.4995C10.3005 14.2491 10.1098 14.3281 9.96912 14.4687C9.82847 14.6094 9.74945 14.8001 9.74945 14.9991V19.4992C9.74945 19.698 9.67045 19.8888 9.52981 20.0294C9.38918 20.1701 9.19844 20.2491 8.99954 20.2492L4.50009 20.2497C4.40159 20.2498 4.30406 20.2304 4.21305 20.1927C4.12205 20.155 4.03936 20.0998 3.9697 20.0301C3.90005 19.9605 3.8448 19.8778 3.8071 19.7868C3.7694 19.6958 3.75 19.5982 3.75 19.4997V10.8316C3.75 10.7271 3.77183 10.6238 3.8141 10.5282C3.85637 10.4326 3.91814 10.347 3.99545 10.2767L11.4949 3.45778C11.633 3.33226 11.8129 3.2627 11.9995 3.2627C12.186 3.26269 12.3659 3.33223 12.504 3.45775L20.0045 10.2767C20.0818 10.347 20.1436 10.4326 20.1859 10.5282C20.2282 10.6238 20.25 10.7271 20.25 10.8316V19.4997C20.25 19.5982 20.2306 19.6958 20.1929 19.7868C20.1552 19.8778 20.1 19.9605 20.0303 20.0301C19.9606 20.0998 19.878 20.155 19.7869 20.1927C19.6959 20.2304 19.5984 20.2498 19.4999 20.2497L14.9994 20.2492C14.8005 20.2491 14.6097 20.1701 14.4691 20.0295C14.3285 19.8888 14.2494 19.698 14.2495 19.4992V19.4992Z",
    stroke: "#A7A7A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseWhiteV1);
export default __webpack_public_path__ + "static/media/house-white-v1.e2cf70a61730e60703df33c22068fdbd.svg";
export { ForwardRef as ReactComponent };